import React from "react";
import "../App.css"; // ensure you have styles for alert

export default function Alert({ type = "info", message, onClose }) {
  if (!message) return null;

  return (
    <div className={`alert ${type}`}>
      <span>{message}</span>
      {onClose && (
        <button className="close-btn" onClick={onClose}>
          &times;
        </button>
      )}
    </div>
  );
}
